import React from 'react'
import './style.scss'
import ReactLoading from 'react-loading'

function ButtonSave({ load, name = 'SALVAR', icon, ...props }) {

    const styleButton = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }

    const isDarkMode = document.body.classList.contains('dark-mode') || document.body.getAttribute('data-theme') === 'dark';
    const loaderColor = isDarkMode ? '#2F3437' : '#FFFFFF';

    return (
        <>
            <button disabled={load ? load : false} {...props} className="btn btn-primary btn-save" type="submit" style={styleButton} >
                {
                    load ?
                        <ReactLoading type='cylon' color={loaderColor} height={30} width={30} />
                        :
                        <>
                            {
                                name
                            }
                            {
                                icon && icon
                            }
                        </>
                }
            </button>
        </>
    )
}

export default ButtonSave